module.exports = __webpack_public_path__ + "static/media/JourneyIcon2.d670570e.png";